<template>
  <div>
    <maintenance-info />
    <bm-privacy />
    <div class="container">
      <topup-header />
      <router-view />
      <topup-footer />
    </div>
  </div>
</template>

<script>
import TopupHeader from './components/Topup/Header'
import TopupFooter from './components/Topup/Footer'
import backUrlParamMixin from '../common/mixins/params/backUrl.mixin'
import piwikToolMixin from '../common/mixins/tools/piwik.mixin'
import MaintenanceInfo from '@/common/components/maintenanceInfo'

export default {
  mixins: [
    backUrlParamMixin,
    piwikToolMixin
  ],
  components: {
    MaintenanceInfo,
    TopupFooter,
    TopupHeader
  }
}
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>
